import { MinusIcon, PlusIcon } from 'lucide-react'
import React from 'react'

import './style.scss'

function Faq({ arrFaq }) {
  const [showFaq, setShowFaq] = React.useState([])

  const onShowFaq = (id) => () => {
    if (showFaq.includes(id)) {
      setShowFaq((prev) => prev.filter((item) => item !== id))
    } else {
      setShowFaq([...showFaq, id])
    }
  }

  return (
    <div className='bridge-faq'>
      <div className='bridge-faq-container'>
        <div className='bridge-faq-content'>
          <div className='bridge-faq__title'>FAQ</div>

          <div className='bridge-faq__content'>
            {arrFaq.map((item, index) => {
              const itemActive = showFaq.includes(item.id)

              return (
                <div className='faq-item' key={index}>
                  <div
                    className={`faq-item__question ${
                      itemActive && 'faq-item__question--active'
                    }`}
                    onClick={onShowFaq(item.id)}>
                    <div className='question-text'>{item.question}</div>

                    {itemActive ? (
                      <MinusIcon className='icon-question' />
                    ) : (
                      <PlusIcon className='icon-question' />
                    )}
                  </div>

                  <div
                    className={`faq-item__answer ${
                      itemActive && 'faq-item__answer--show'
                    }`}>
                    <div
                      className='answer-text'
                      dangerouslySetInnerHTML={{ __html: item.answer }}></div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Faq
